'use client';

/* eslint-disable @next/next/no-img-element -- already a small webp, and private to logged-in users, which the image optimiser cannot fetch */
import { c as _c } from "react/compiler-runtime";
import type React from 'react';
import { useState } from 'react';

/**
 * A profile picture laid over the initials below it. When it cannot be loaded, e.g. offline or
 * after the picture was removed, it steps aside and the initials show.
 */
export const AvatarPicture: React.FC<{
  src: string;
}> = t0 => {
  const $ = _c(6);
  const {
    src
  } = t0;
  const [failedSource, setFailedSource] = useState();
  if (failedSource === src) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <></>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  let t1;
  if ($[1] !== src) {
    t1 = () => setFailedSource(src);
    $[1] = src;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== src || $[4] !== t1) {
    t2 = <img src={src} alt="" loading="lazy" decoding="async" className="absolute inset-0 h-full w-full rounded-full object-cover" onError={t1} />;
    $[3] = src;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};